import styles from '../searchfiltertoggle.module.scss';
import { Button } from '../../button/Button';
import { Icon } from '../../icons/Icon';

type SearchInputProps = {
  searchInputIcon: string;
  searchInputIconAltText: string;
  searchInputPlaceholder: string;
  searchTerm: string;
  isOpen: boolean;
  arrowUpIconSelect: string;
  arrowUpAria: string;
  filterIcon: string;
  filterIconAriaLabel: string;
  arrowDownSelect: string;
  arrowDownAria: string;
  memoizedHandleSearchInput: (value: string) => void;
  IconCloseTooltip?: string;
};

export function SearchInput({
  isOpen,
  filterIcon,
  filterIconAriaLabel,
  searchInputIcon,
  searchInputIconAltText,
  searchInputPlaceholder,
  arrowUpIconSelect,
  arrowUpAria,
  arrowDownSelect,
  arrowDownAria,
  searchTerm,
  IconCloseTooltip,
  memoizedHandleSearchInput,
}: Readonly<SearchInputProps>) {
  return (
    <div className={styles['cmp-search-filter__search-container']}>
      <div className={styles['cmp-search-filter__search-input-wrapper']}>
        {searchInputIcon && (
          <Icon
            icon={searchInputIcon}
            ariaLabel={searchInputIconAltText}
            styleOption={`${styles['cmp-search-filter__search-icon']} icon-medium`}
            onClick={(e: MouseEvent) => e.stopPropagation()}
          />
        )}
        <input
          className={styles['cmp-search-filter__search-input']}
          type="text"
          placeholder={searchInputPlaceholder}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          onChange={(e) => memoizedHandleSearchInput(e.target.value)}
          value={searchTerm}
          tabIndex={0}
        />
      </div>
      <Button
        icon={(isOpen && arrowUpIconSelect) || filterIcon || arrowDownSelect || ''}
        iconAriaLabel={(isOpen && arrowUpAria) || filterIconAriaLabel || arrowDownAria || ''}
        styleOption={
          'cmp-button__secondary -icon-only -no-outline -negative cmp-search-filter__toggle-icon'
        }
        tooltipText={IconCloseTooltip}
        ariaHidden={true}
      />
    </div>
  );
}
